(() => {
  if (customElements.get('f4-product')) return;
  customElements.define('f4-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const data = this.querySelector('[data-f4-data]');
      if (!data) { this.ready = false; return; }
      const config = JSON.parse(data.textContent);
      const $ = s => this.querySelector(s);
      const all = s => [...this.querySelectorAll(s)];
      const form = $('form'), native = $('[name="id"]'), quantity = $('[name="quantity"]');
      const add = $('[data-add]'), buy = $('[data-buy]');
      const groups = all('[data-option-index]');
      let selections = config.selected.slice(), current, busy = false, mediaIndex = 0;
      const thumbs = all('[data-media-src]');
      const main = $('.f4-gallery-main > img');
      const notice = (message, error = false) => {
        const toast = $('.f4-toast');
        toast.classList.add('is-visible');
        toast.setAttribute('tabindex','-1');
        toast.focus({preventScroll:true});
        toast.scrollIntoView({block:'nearest',behavior:'auto'});
        toast.classList.toggle('is-error', error);
        $('.f4-toast__msg').textContent = message;
        const link = $('[data-cart-link]');
        if (link) link.hidden = error;
      };
      const media = index => {
        if (!main || !thumbs.length) return;
        mediaIndex = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[mediaIndex];
        main.removeAttribute('srcset');
        main.src = thumb.dataset.mediaSrc;
        main.alt = thumb.querySelector('img').alt;
        thumbs.forEach((t, i) => { t.classList.toggle('is-active', i === mediaIndex); t.setAttribute('aria-pressed', String(i === mediaIndex)); });
      };
      const sync = (changeImage = false) => {
        current = config.variants.find(v => v.options.every((o, i) => o === selections[i]));
        native.value = current ? String(current.id) : '';
        const purchasable = current && current.available && current.price > 0;
        add.disabled = buy.disabled = busy || !purchasable;
        add.textContent = busy ? 'Adding…' : !current ? 'Unavailable combination' : purchasable ? config.addLabel : 'Sold out';
        buy.textContent = config.buyLabel;
        form.setAttribute('aria-busy', String(busy));
        $('[data-price]').textContent = current ? (current.price > 0 ? current.priceText : 'Price coming soon') : 'Unavailable';
        $('[data-compare]').textContent = current?.compareText || '';
        $('[data-compare]').hidden = !current?.discount;
        $('[data-discount]').textContent = current?.discount ? `${current.discount}% OFF` : '';
        $('[data-discount]').hidden = !current?.discount;
        $('[data-status]').textContent = !current ? 'This combination is not available. Choose another option.' : !purchasable ? 'This option is currently sold out.' : '';
        groups.forEach((group, i) => {
          group.previousElementSibling.querySelector('span').textContent = selections[i];
          group.querySelectorAll('button').forEach(button => {
            const selected = button.dataset.value === selections[i];
            const available = config.variants.some(v => v.available && v.price > 0 && v.options.every((value, j) => value === (j === i ? button.dataset.value : selections[j])));
            button.classList.toggle('is-selected', selected);
            button.classList.toggle('is-unavailable', !available);
            button.setAttribute('aria-pressed', String(selected));
            button.title = button.dataset.value + (available ? '' : ' — unavailable with current options');
            button.disabled = busy;
          });
        });
        quantity.disabled = busy;
        const rule = current?.quantityRule || {min:1, increment:1};
        quantity.min = rule.min || 1; quantity.step = rule.increment || 1;
        const maximum = current?.inventoryManaged ? Math.min(current.inventoryQuantity, rule.max || Infinity) : rule.max;
        if (Number.isFinite(maximum)) quantity.max = maximum; else quantity.removeAttribute('max');
        if (Number.isFinite(maximum) && Number(quantity.value) > maximum) quantity.value = Math.max(Number(quantity.min), maximum);
        const stock = $('[data-stock]');
        if (stock) stock.textContent = !purchasable ? 'Currently unavailable' : current.inventoryManaged ? current.inventoryQuantity + ' available in this option' : 'Available to order';
        document.dispatchEvent(new CustomEvent('f4:variant', {detail:{id:current?.id,price:current?.priceText,available:!!purchasable,busy}}));
        if (Number(quantity.value) < Number(quantity.min)) quantity.value = quantity.min;
        if (changeImage && current?.mediaId) {
          const i = thumbs.findIndex(t => t.dataset.mediaId === String(current.mediaId));
          if (i >= 0) media(i);
        }
        if (changeImage && config.updateUrl && current && !config.preview) {
          const url = new URL(location.href); url.searchParams.set('variant', current.id); history.replaceState({}, '', url);
        }
      };
      groups.forEach((group, i) => group.querySelectorAll('button').forEach(button => button.addEventListener('click', () => { selections[i] = button.dataset.value; sync(true); })));
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => media(i)));
      $('.f4-gallery-arrow--prev')?.addEventListener('click', () => media(mediaIndex - 1));
      $('.f4-gallery-arrow--next')?.addEventListener('click', () => media(mediaIndex + 1));
      all('[data-action]').forEach(button => button.addEventListener('click', () => {
        if (busy) return;
        if (!quantity.value || !Number.isFinite(Number(quantity.value))) quantity.value = quantity.min;
        if (button.dataset.action === 'increase') quantity.stepUp(); else quantity.stepDown();
      }));
      const submit = async checkout => {
        if (busy || !current?.available || current.price <= 0 || !form.reportValidity()) return;
        const id = current.id, count = Number(quantity.value);
        if (!Number.isInteger(count) || count < 1) return;
        busy = true; sync();
        try {
          if (config.preview) {
            await new Promise(resolve => setTimeout(resolve, 250));
            notice(checkout ? 'Preview only — checkout is not connected.' : `Preview: ${count} item${count === 1 ? '' : 's'} added. No real cart was changed.`);
          } else {
            const response = await fetch(config.addUrl, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[{id, quantity:count}]})});
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
            if (checkout) { location.assign(config.checkoutUrl); return; }
            notice('Added to your cart.');
            fetch(config.cartUrl + '.js').then(r => { if (!r.ok) throw new Error(); return r.json(); }).then(cart => document.dispatchEvent(new CustomEvent('cart:update', {detail:{cart}}))).catch(() => {});
          }
        } catch (error) { notice(error instanceof TypeError ? 'Connection interrupted. Check your cart before trying again.' : error.message, true); }
        finally { busy = false; sync(); }
      };
      form.addEventListener('submit', event => { event.preventDefault(); submit(false); });
      buy.addEventListener('click', () => submit(true));
      this.classList.add('f4-enhanced');
      sync(true);
    }
  });
})();

